import styled from '@emotion/styled';
import { font } from '../../style-utils/text';
import {
  palette,
  radius,
  shadow,
  spacing,
  layout,
  typography,
  transition,
} from '../../style-utils/theme';
import { down } from '../../style-utils/media-queries';

/**
 * Text/number field. 48px tall, hairline resting border with a whisper of
 * elevation; hover strengthens the border, focus lights the iris ring.
 */
export const StyledInputWrapper = styled.input<{ width: number }>`
  align-self: center;
  box-sizing: border-box;
  width: ${({ width }) => (width ? `${width}%` : '100%')};
  max-width: 420px;
  height: ${layout.fieldHeight};
  padding: 0 ${spacing.sm};
  border-radius: ${radius.xs};
  border: 1px solid ${palette.line};
  background: ${palette.surface};
  color: ${palette.ink};
  margin-bottom: ${spacing.sm};
  box-shadow: ${shadow.xs};
  font-family: ${font.family};
  font-size: ${typography.size.base}px;
  transition: ${transition.colors};

  &::placeholder {
    color: ${palette.slateLight};
  }

  &:hover {
    border-color: ${palette.lineStrong};
  }

  &:focus {
    outline: none;
    border-color: ${palette.lagoon};
    box-shadow: ${shadow.focus};
  }

  ${down('sm')} {
    width: 100%;
  }

  /* Hide the up and down arrows for Webkit browsers */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Hide the arrows for Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }

  /* Hide the arrows for Internet Explorer */
  &::-ms-clear {
    display: none;
  }
`;
